module.exports = __webpack_public_path__ + "img/icon5.f97d14b1.png";